import { render, staticRenderFns } from "./ListHistory.vue?vue&type=template&id=3b72da62&scoped=true"
import script from "./ListHistory.vue?vue&type=script&lang=ts"
export * from "./ListHistory.vue?vue&type=script&lang=ts"
import style0 from "./ListHistory.vue?vue&type=style&index=0&id=3b72da62&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../DATA/projects/nguonhangchina/client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b72da62",
  null
  
)

export default component.exports